import DateTimePicker from "@/modules/common/components/ui/date-picker/date-time-picker";
import { Box } from "@mui/material";

const EditDateOfLastRequest = ({
  autoFocus,
  dateOfLastRequest,
}: {
  dateOfLastRequest: {
    state: Date | Date[] | null | string;
    setDateOfLastRequest: (date: Date | Date[] | null | string) => void;
  };
  autoFocus?: boolean;
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 1,
        width: "100%",
      }}
    >
      <DateTimePicker
        date={
          dateOfLastRequest.state && !(dateOfLastRequest.state instanceof Array)
            ? new Date(dateOfLastRequest.state)
            : null
        }
        defaultValue={
          dateOfLastRequest.state && !(dateOfLastRequest.state instanceof Array)
            ? new Date(dateOfLastRequest.state)
            : undefined
        }
        setDate={dateOfLastRequest.setDateOfLastRequest}
        label="Date of Last Request"
        maxDate={new Date()}
        autoFocus={autoFocus}
        ignoreTopPadding={false}
      />
    </Box>
  );
};

export default EditDateOfLastRequest;
